export const examTableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
	  {
      label: '考试名称',
      prop: 'title',
      overHidden: true,
    },
    {
      label: '考试描述',
      prop: 'description',
      overHidden: true,
    },
    {
      label: '考试详情链接',
      prop: 'examInfoUrl',
      solt: true,
    },
    {
      label: '分类',
      prop: 'category',
    },
    {
      label: '考试开始时间',
      prop: 'startedTime',
    },
    {
      label: '考试结束时间',
      prop: 'endedTime',
    },
    {
      label: '状态',
      prop: 'status',
    },
    {
      label: '考试时长',
      prop: 'duration',
    },
    {
      label: '创建人',
      prop: 'username',
      overHidden: true,
    },
    {
      label: '创建时间',
      prop: 'insertedTime',

    },
  ]
}

export const examResultTableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  menu: false,
  columnBtn: false,
  column: [
	  {
      label: '用户名',
      prop: 'nickname',
      overHidden: true,
    },
    {
      label: '考试次数',
      prop: 'submitCount',
    },
    {
      label: '成绩',
      prop: 'totalScore',
    },
    {
      label: '是否通过',
      prop: 'pass',
    },
  ]
}

export const examStatusOption = [
  {
    label: '未发布',
    value: 1
  },
  {
    label: '已发布',
    value: 2
  },
  {
    label: '进行中',
    value: 3
  },
  {
    label: '已结束',
    value: 4
  },
  {
    label: '已废弃',
    value: 5
  }
]

export const examStatusMap = {
  NO_PUBLISHED: {
    code: 'NO_PUBLISHED',
    name: '未发布',
    value: 1
  },
  PUBLISHED: {
    code: 'PUBLISHED',
    name: '已发布',
    value: 2
  },
  PROCESSING: {
    code: 'PROCESSING',
    name: '进行中',
    value: 3
  },
  ENDED: {
    code: 'ENDED',
    name: '已结束',
    value: 4
  },
  ABORTED: {
    code: 'ABORTED',
    name: '已废弃',
    value:5
  },
}

export const examCategoryMap = {
  'fixed': 1,
  'random' : 2,
}

export const examCategoryOption = [
  {
    label: '基础能力',
    value: 1
  },
  {
    label: '普通测试',
    value: 2
  }
]
